module.exports = __webpack_public_path__ + "img/yu_btn.ef6f81db.png";